<template lang="pug">
box
  page-title(slot="page-title", title="Documentos")
    verificar-doc(slot="action" button-class="btn btn-link")
  div(slot="content")
    .container.grid-lg.pt-2
      filter-form.px-2
      list-manager.scrollable(
        :errors="[]",
        :loading="loading",
        :pages="pages",
        :page="page",
        :prev="prevPage",
        :next="nextPage",
        :count="list.length",
        :first="firstPage",
        :last="lastPage"
      )
        table.table.table-striped.table-hover
          thead
            tr
              th Número
              th Cadastro
              th Emitido em
              th Situação
              th.text-right Valor total
              th(width="80px")
          tbody
            tr(v-for="doc in list")
              td {{ doc.numero }} / {{ doc.ano }}
              td {{ doc.cadastro ? doc.cadastro.numero : "-" }}
              td {{ doc.created_at | date }}
              td {{ doc.situacao.descricao }}
              td.text-right {{ doc.valor_total | currency("R$ ") }}
              td.text-right.actions-col
                .actions
                  router-link.tooltip.tooltip-left(
                    :data-tooltip="'views.buttons.show.label' | translate",
                    :to="`/app/docs/${doc.id}`"
                  )
                    i.fa.fa-eye.fa-lg
</template>

<script>
import FilterForm from "./Filter.vue";

export default {
  vuex: {
    docs: {
      state: ["list", "page", "pages", "count", "query"],
      getters: ["loading", "filtered"],
      actions: [
        "fetchList",
        "fetchRemove",
        "prevPage",
        "nextPage",
        "firstPage",
        "lastPage",
      ],
      mutations: ["setQuery"],
    },
  },
  components: { FilterForm },
};
</script>
